import { render, staticRenderFns } from "./MigrateToOBKFlow.vue?vue&type=template&id=53fe2d7c&scoped=true"
import script from "./MigrateToOBKFlow.vue?vue&type=script&lang=js"
export * from "./MigrateToOBKFlow.vue?vue&type=script&lang=js"
import style0 from "./MigrateToOBKFlow.vue?vue&type=style&index=0&id=53fe2d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fe2d7c",
  null
  
)

export default component.exports